var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"multiselector"},[_c('div',{staticClass:"item"},[_c('vue-part',{attrs:{"id":5}}),_c('vue-part',{attrs:{"id":1}})],1),_c('div',{staticClass:"item"},[_c('vue-part',{attrs:{"id":2}})],1),_c('div',{staticClass:"item"},[_c('vue-part',{attrs:{"id":3}}),_c('vue-part',{attrs:{"id":4}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }